import { createContext, useContext } from "react";
import { MusicReturnProps } from "./types";
import { useMusicQuery } from "@utils/queries";

const musicContext = createContext<MusicReturnProps | null>(null);
const { Provider } = musicContext;
type Props = {
  children: React.ReactNode;
};
export function MusicProvider({ children }: Props) {
  const {
    data: musicChannels = [],
    status,
    refetch,
  } = useMusicQuery.playlists(true);

  return (
    <Provider
      value={{
        musicChannels,
        musicFetchStatus: status,
        refetchMusic: refetch,
      }}
    >
      {children}
    </Provider>
  );
}

export const useMusic = () => {
  const context = useContext(musicContext);
  if (!context) throw "useMusic must be used within a MusicProvider";
  return context;
};
